import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { connectionState, getDisconnectCount, getDisplayState } from '../features/connection/connectionSlice';
import { getID } from '../features/room/roomSlice';
import { Button } from './Button';

import './ConnectionStatus.css';

export const ConnectionStatus = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const state = useSelector(getDisplayState);
  const count = useSelector(getDisconnectCount);
  const roomID = useSelector(getID);

  if (count === 0 || (state !== connectionState.DISCONNECTED && state !== connectionState.CONNECTING)) {
    return null;
  }

  const button = (() => {
    switch (state) {
      case connectionState.DISCONNECTED:
        return <Button onClick={e => dispatch({type: 'action/joinroom', payload: { id: roomID, reconnect: true }})}>{t('CONNECT')}</Button>;
      case connectionState.CONNECTING:
        return <Button disabled={true}>{t('CONNECTING...')}</Button>;
      default:
        return null;
    }
  })();

  return (
    <div className="connectionStatus contentArea">
      <div>
        <div>
          <Trans t={t} i18nKey="DISCONNECTED_MSG">
            <b>Offline</b> Please connect!
          </Trans>
        </div>
        <div>
          {button}
        </div>
      </div>
    </div>
  );
};